import axios from 'axios';

class HttpClient {

  baseURL = 'http://localhost/';

  constructor(config = {}) {
    this.axios = axios.create({
      timeout: 60000,
      ...config
    });
  }

  setBaseUrl(baseURL) {
    this.baseURL = baseURL;
  }

  request(config) {
    return this.axios.request(config);
  }

  get(url, config = {}) {
    return this.axios.get(url, this.getConfig(config));
  }

  delete(url, config = {}) {
    return this.axios.delete(url, this.getConfig(config));
  }

  head(url, config = {}) {
    return this.axios.head(url, this.getConfig(config));
  }

  options(url, config = {}) {
    return this.axios.options(url, this.getConfig(config));
  }

  post(url, data = {}, config = {}) {
    return this.axios.post(url, data, this.getConfig(config))
  }

  put(url, data = {}, config = {}) {
    return this.axios.put(url, data, this.getConfig(config))
  }

  patch(url, data = {}, config = {}) {
    return this.axios.patch(url, data, this.getConfig(config))
  }

  getConfig(config) {
    config = config ? { ...config } : {};

    config.baseURL = this.baseURL;

    return config;
  }

  onRequest(onSuccess, onError) {
    this.axios.interceptors.request.use(onSuccess, onError);
  }

  onResponse(onSuccess, onFailure) {
    this.axios.interceptors.response.use(onSuccess, onFailure);
  }

}

export default HttpClient;